<template>
    <div class="selectWrapper">
      <div class="info">동&nbsp;&nbsp;(세대수)</div>
      <div class="select">
        <div v-for="(data, key) in complexListBuidingArray.building" :key="key"
          @click="selectBuilding(key, data.code)" :class="{ 'active': selectedBuildingKey === key }">
          <p>{{ key }}&nbsp;&nbsp;({{ data.houses }})</p>
        </div>
      </div>
    </div>
    <div class="selectWrapper">
      <div class="info">호</div>
      <div class="select">
        <div v-if="selectedBuildingKey !== -1">
          <div v-for="(data, key) in complexListBuidingArray.building[selectedBuildingKey].house" :key="key"
            @click="selectHouse(key, data.code)" :class="{ 'active': selectedHouseKey === key }">
            <p>{{ key }}&nbsp;&nbsp;{{ changeState(data.state) }}</p>
          </div>
        </div>
        <div v-else>
          <p>동을 선택하세요</p> 
        </div>
      </div>
    </div>
    <div class="content">
      <div class="infoWrapper">
        <div>
          <p class="title">기초정보</p>
        </div>
        <div class="data">
          <label for="myInput" style="float:left; margin-right:10px;"><p>세대</p></label>
          <v-text-field variant="outlined" hide-details density="compact" class="custom-input" 
          v-model="dongho" readonly>
          </v-text-field>
        </div>
        <div class="data">
          <label for="myInput" style="float:left; margin-right:10px;"><p>입주/퇴거일</p></label>
          <v-date-input v-model="moved" label="" variant="outlined" density="compact" prepend-icon="" placeholder=""
          class="custom-date-input" hide-details></v-date-input>
        </div>
        <div class="data" style="clear:both;">
          <label for="myInput" style="float:left; margin-right:10px;"><p>평형</p></label>
          <v-text-field v-model="type" variant="outlined" hide-details density="compact" class="custom-input" radonly
          ></v-text-field>
        </div>
        <div class="data">
          <label for="myInput" style="float:left; margin-right:10px;"><p>입주 상태</p></label>
          <v-select v-model="state" :items="stateArray" variant="outlined" hide-details density="compact">
          </v-select>
        </div>
        <div class="data">
          <label for="myInput" style="float:left; margin-right:10px;"><p>입주형태</p></label>
          <v-select v-model="own" :items="ownArray" variant="outlined" hide-details density="compact">
         </v-select>
        </div>
        <div class="data2">
          <label for="myInput" style="float:left; margin-right:10px;"><p>노트</p></label>
          <v-textarea
            v-model="note" variant="outlined" hide-details density="compact" rows="3" class="custom-textarea"
          ></v-textarea>
        </div>
        <div class="buttonWrapper">
          <v-btn @click="houseUpdateManager" color="#d9e1f1" rounded="10px" size="large" class="mr-4 float-right btn">
            등록
          </v-btn>
          <v-btn @click="houseLeave" color="#d9e1f1" rounded="10px" size="large" class="mr-4 float-right btn">
            퇴거
          </v-btn>
        </div>
      </div>

      <div class="table_wrapper">
        <div>
          <p class="title">입주자정보</p>
          <div class="buttonWrapper">
            <v-btn v-on:click="residentPopUpOpen" color="#d9e1f1" rounded="10px" size="large" class="mt-2 mr-4 float-right btn">
              추가
            </v-btn>
          </div>
        </div>
        <v-table class="table" fixed-header>
          <thead>
            <tr>
              <th class="text-left">이름</th>
              <th class="text-left">구분</th>
              <th class="text-left">생일</th>
              <th class="text-left">성별</th>
              <th class="text-left">전화번호</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in residentArray" :key="item.seq" 
            v-on:click="regidentGetInformation(item.code)"
            :class="{'active': residentCode === item.code}">
              <td>{{ item.name }}</td>
              <td>{{ checkResidentPosition(item.position) }}</td>
              <td>{{ item.birth }}</td>
              <td>{{ checkResidentSex(item.sex) }}</td>
              <td>{{ item.mobile }}</td>
            </tr>
          </tbody>
        </v-table>

      </div>
      <div class="table_wrapper">
        <div>
          <p class="title">차량정보</p>
          <div class="buttonWrapper">
            <v-btn v-on:click="vehiclePopUpOpen" color="#d9e1f1" rounded="10px" 
              size="large" class="mt-2 mr-4 float-right btn">
              추가
            </v-btn>
          </div>
        </div>
        <v-table class="table" fixed-header>
          <thead>
            <tr>
              <th class="text-left">등록일</th>
              <th class="text-left">차량번호</th>
              <th class="text-left">차종</th>
              <th class="text-left">연료</th>
              <th class="text-left">승인번호</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in vehicleArray" :key="item.seq" 
            v-on:click="vehicleGetInformation(item.code)"
            :class="{'active': vehicleCode === item.code}">
              <td>{{ item.registered }}</td>
              <td>{{ item.plate_number }}</td>
              <td>{{ item.name }}</td>
              <td>{{ checkVehicleFuel(item.fuel) }}</td>
              <td>{{ item.access_number }}</td>
            </tr>
          </tbody>
        </v-table>
      </div>
      <div class="popup_wrapper"  v-show="residentPopUpCheck">
        <div class="title">
          입주자정보
        </div>
        <div class="popup_content">
          <v-row class="my-input-row">
            <v-col cols="3" class="text-right pa-1">
              <label for="myInput">이름</label>
            </v-col>
            <v-col cols="8" class="pa-1">
              <v-text-field v-model="residentName" id="myInput" variant="outlined" hide-details density="compact" class="custom-input"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-input-row">
            <v-col cols="3" class="text-right pa-1">
              <label for="myInput">구분</label>
            </v-col>
            <v-col cols="8" class="pa-1">
              <v-select v-model="residentPosition" :items="positionArray" variant="outlined" hide-details density="compact">
              </v-select>
            </v-col>
          </v-row>
          <v-row class="my-input-row">
            <v-col cols="3" class="text-right pa-1">
              <label for="myInput">생일</label>
            </v-col>
            <v-col cols="8" class="pa-1">
              <v-date-input v-model="residentBirth" class="custom-date-input"  label="" variant="outlined" density="compact" prepend-icon="" placeholder=""
                   hide-details></v-date-input>
            </v-col>
          </v-row>
          <v-row class="my-input-row">
            <v-col cols="3" class="text-right pa-1">
              <label for="myInput">성별</label>
            </v-col>
            <v-col cols="8" class="pa-1">
              <v-select v-model="residentSex" :items="sexArray" variant="outlined" hide-details density="compact">
              </v-select>
            </v-col>
          </v-row>
          <v-row class="my-input-row">
            <v-col cols="3" class="text-right pa-1">
              <label for="myInput">전화번호</label>
            </v-col>
            <v-col cols="8" class="pa-1">
              <v-text-field  v-model="residentMobile" id="myInput" variant="outlined" hide-details density="compact" class="custom-input"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <div class="popup_footer">
          <v-btn v-if="!residentState" v-on:click="residentRegister" color="#31487a" rounded="10px" size="large" class="mr-4 float-right btn">
            등록
          </v-btn>
          <v-btn v-if="residentState" v-on:click="residentUpdate" color="#31487a" rounded="10px" size="large" class="mr-4 float-right btn">
            등록
          </v-btn>
          <v-btn v-if="residentState" v-on:click="residentRemove" color="#d9e1f1" rounded="10px" size="large" class="mr-4 float-right btn">
            삭제
          </v-btn>
          <v-btn v-on:click="residentPopUpClose" color="#d9e1f1" rounded="10px" size="large" class="mr-4 float-right btn">
            닫기
          </v-btn>
        </div>
      </div>
      <div class="popup_wrapper"  v-show="vehiclePopUpCheck">
        <div class="title">
          차량 정보
        </div>
        <div class="popup_content">
          <v-row class="my-input-row">
            <v-col cols="3" class="text-right pa-1">
              <label for="myInput">등록일</label>
            </v-col>
            <v-col cols="8" class="pa-1">
              <v-date-input v-model="vehicleRegistered" label="" variant="outlined" density="compact" prepend-icon="" placeholder=""
                  class="custom-date-input" hide-details></v-date-input>
            </v-col>
          </v-row>
          <v-row class="my-input-row">
            <v-col cols="3" class="text-right pa-1">
              <label for="myInput">차량번호</label>
            </v-col>
            <v-col cols="8" class="pa-1">
              <v-text-field  v-model="vehiclePlateNumber" id="myInput" variant="outlined" hide-details density="compact" class="custom-input"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-input-row">
            <v-col cols="3" class="text-right pa-1">
              <label for="myInput">차종</label>
            </v-col>
            <v-col cols="8" class="pa-1">
              <v-text-field  v-model="vehicleName" id="myInput" variant="outlined" hide-details density="compact" class="custom-input"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="my-input-row">
            <v-col cols="3" class="text-right pa-1">
              <label for="myInput">연료</label>
            </v-col>
            <v-col cols="8" class="pa-1">
              <v-select v-model="vehicleFuel" :items="fuelArray" variant="outlined" hide-details density="compact" class="custom-input">
              </v-select>
            </v-col>
          </v-row>
          <v-row class="my-input-row">
            <v-col cols="3" class="text-right pa-1">
              <label for="myInput">승인번호</label>
            </v-col>
            <v-col cols="8" class="pa-1">
              <v-text-field  
                v-model="vehicleAccessNumber" id="myInput" variant="outlined" hide-details density="compact" class="custom-input"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <div class="popup_footer">
          <v-btn v-if="!vehicleState" v-on:click="vehicleRegister" color="#31487a" rounded="10px" size="large" class="mr-4 float-right btn">
            등록
          </v-btn>
          <v-btn v-if="vehicleState" v-on:click="vehicleUpdate" color="#31487a" rounded="10px" size="large" class="mr-4 float-right btn">
            등록
          </v-btn>
          <v-btn v-if="vehicleState" v-on:click="vehicleRemove" color="#d9e1f1" rounded="10px" size="large" class="mr-4 float-right btn">
            삭제
          </v-btn>
          <v-btn v-on:click="vehiclePopUpClose" color="#d9e1f1" rounded="10px" size="large" class="mr-4 float-right btn">
            닫기
          </v-btn>
        </div>
      </div>

    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { VDateInput } from 'vuetify/labs/VDateInput';
import dayjs from 'dayjs'
// Components

export default defineComponent({
  name: 'HomeView',
  props: {
    complex: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    residentPopUpCheck:false,
    vehiclePopUpCheck:false,
    complexListBuidingArray:[],
    houseInformation:[],
    selectedBuildingKey: -1,
    selectedBuildingCode: '',
    selectedHouseKey : -1,
    selectedHouseCode: '',
    unitNumber: '', 
    dongho: '',
    moved: dayjs().format('YYYY-MM-DD'),
    type: '',
    state: '',
    own: '',
    note: '',
    residentArray: [],
    vehicleArray: [],
    residentMemberArray: [],
    stateArray: [
        { title: '입주', value: 'R'},
        { title: '퇴거', value: 'L'}
      ],
    ownArray: [
        { title: '자가', value: 'O'},
        { title: '전세', value: 'L'},
        { title: '월세', value: 'R'}
      ],
    sexArray: [
        { title: '남', value: 'M'},
        { title: '여', value: 'F'}
      ],
    positionArray: [
        { title: '세대주', value: 'H'},
        { title: '세대원', value: 'F'}
      ],  
    fuelArray: [
        { title: '가솔린', value: 'G'},
        { title: '디젤', value: 'D'},
        { title: 'LPG', value: 'L'},
        { title: '전기', value: 'E'},
        { title: '하이브리드', value: 'H'},
        { title: '수소', value: 'F'}
      ],  
    residentCode: -1,
    residentName: '',
    residentMobile: '',
    residentPosition: '',
    residentSex: '',
    residentBirth: dayjs().format('YYYY-MM-DD'),
    vehicleCode: -1,
    vehiclePlateNumber: '',
    vehicleName: '',
    vehicleFuel: '',
    vehicleAccessNumber: '',
    vehicleRegistered: dayjs().format('YYYY-MM-DD'),
    vehicleState: false,
    residentState: false,
  }),
  components: {
    VDateInput
  },
  mounted() {
    this.getComplexListBuilding();
  },
  methods:{
    changeState(reply) {
        if (reply === 'R') {
            return '입주';
        } else {
            return '';
        }
    },
    clear(){
      this.dongho = '';
      this.moved = '';
      this.type = '';
      this.own = '';
      this.state = '';
      this.note = '';
      this.selectedHouseCode = '';
      this.residentArray= [];
      this.vehicleArray= [];
      this.vehicleCode = -1;
      this.residentCode = -1;
      this.residentPopUpCheck = false;
      this.vehiclePopUpCheck = false;
    },  
    residentClear(){
      this.residentCode='';
      this.residentName = '';
      this.residentMobile = '';
      this.residentPosition = '';
      this.residentSex = '';
      this.residentCode = -1;
      this.residentBirth = dayjs().format('YYYY-MM-DD');
    },
    vehicleClear(){
      this.vehicleCode='';
      this.vehiclePlateNumber = '';
      this.vehicleName = '';
      this.vehicleFuel = '';
      this.vehicleAccessNumber = '';
      this.vehicleCode = -1;
      this.vehicleRegistered = dayjs().format('YYYY-MM-DD');
    },
    format(date) {
      return dayjs(date).format('YYYY-MM-DD') 
    }, 
    houseLeave(){
      if(this.selectedHouseCode !== ''){
        if(confirm('퇴거처리합니까?')){
          const form = new FormData()
          form.append('house', this.selectedHouseCode);

          this.$axios.post('/task/house_leave.php', form)
          .then(() => {
            this.own = 'O';
            this.state = 'L';
            this.note = '';
            this.selectedHouseCode = '';
            this.residentArray= [];
            this.vehicleArray= [];
            this.getComplexListBuilding();
            this.residentPopUpCheck = false;
            this.vehiclePopUpCheck = false;
            this.residentCode = -1;
            this.vehicleCode = -1;
          })
          .catch(err => {
              console.error('에러 발생:', err)
          })
        }
        
      } else{
        alert('동과 호를 선택하세요');
      }
    },
    houseUpdateManager(){
      if(this.selectedHouseCode !== ''){
        const form = new FormData();
        form.append('house', this.selectedHouseCode);
        form.append('moved', this.format(this.moved));
        form.append('state', this.state);
        form.append('own', this.own);
        form.append('note', this.note);

        this.$axios.post('/task/house_update_manager.php', form)
        .then(res => {
          let result = res.data.result;

          this.moved = result.moved;
          this.type = result.type;
          this.own = result.own;
          this.state = result.state;
          this.note = result.note;
          this.getComplexListBuilding();
          this.residentPopUpCheck = false;
          this.vehiclePopUpCheck = false;
          this.residentCode = -1;
          this.vehicleCode = -1;
        })
        .catch(err => {
            console.error('에러 발생:', err)
        })
      } else{
        alert('동과 호를 선택하세요');
      }
    },
    residentPopUpOpen(){
      if(this.selectedHouseCode === '' ){
        alert('동과 호를 선택하세요');
        return;
      } else{
        this.residentPopUpCheck= true;
        this.vehiclePopUpCheck= false;
      }
    },
    residentPopUpClose(){
      this.residentState = false;
      this.residentClear();
      this.residentPopUpCheck= false;
    },
    vehiclePopUpOpen(){
      if(this.selectedHouseCode === '' ){
        alert('동과 호를 선택하세요');
        return;
      } else{
        this.vehiclePopUpCheck= true;
        this.residentPopUpCheck= false;
      }
    },
    vehiclePopUpClose(){
      this.vehicleState = false;
      this.vehicleClear();
      this.vehiclePopUpCheck= false;
    },
    getComplexListBuilding(){
        const form = new FormData()
        form.append('complex', this.complex);
        this.$axios.post('/task/complex_list_building.php', form)
        .then(res => {
          let result = res.data.result;
          this.complexListBuidingArray = result;
        })
        .catch(err => {
          console.error('에러 발생:', err)
        })
    },
    selectBuilding(key,code){
      this.selectedBuildingKey = key;
      this.selectedBuildingCode = code;
      this.selectedHouseKey = -1;
      this.clear();
    },
    selectHouse(key,code){
      this.clear();
      
      this.selectedHouseKey = key;
      this.selectedHouseCode = code;

      this.dongho =  this.selectedBuildingKey + '동 ' + this.selectedHouseKey + '호';
      
      this.getDetail();
    },
    getDetail(){
      const form = new FormData()
        form.append('house', this.selectedHouseCode);
        this.$axios.post('/task/house_get_information.php', form)

        .then(res => {
            let result = res.data.result;
            this.houseInformation = result;

            this.moved = this.houseInformation.house[0].moved;
            this.type = this.houseInformation.house[0].type;
            this.own = this.houseInformation.house[0].own;
            this.state = this.houseInformation.house[0].state;
            this.note = this.houseInformation.house[0].note;
            this.residentArray = this.houseInformation.resident;
            this.vehicleArray = this.houseInformation.vehicle;
        })
        .catch(err => {
            console.error('에러 발생:', err)
        })
    },
    residentRegister(){
        const form = new FormData()
        form.append('complex', this.complex);
        form.append('building', this.selectedBuildingCode);
        form.append('house', this.selectedHouseCode);
        form.append('name', this.residentName);
        form.append('mobile', this.residentMobile);
        form.append('position', this.residentPosition);
        form.append('sex', this.residentSex);
        form.append('birth', this.format(this.residentBirth));
        this.$axios.post('/task/resident_register_manager.php', form)
        .then(() => {
          this.getDetail();
          this.residentPopUpClose();
        })
        .catch(err => {
          console.error('에러 발생:', err)
        })
    },
    residentUpdate(){
        const form = new FormData()
        form.append('resident', this.residentCode);
        form.append('name', this.residentName);
        form.append('mobile', this.residentMobile);
        form.append('position', this.residentPosition);
        form.append('sex', this.residentSex);
        form.append('birth', this.format(this.residentBirth));
        this.$axios.post('/task/resident_update_manager.php', form)
        .then(() => {
          this.getDetail();
          this.residentClear();
          this.residentPopUpClose();
        })
        .catch(err => {
          console.error('에러 발생:', err)
        })
    },
    residentRemove(){
      if(confirm('삭제하시겠습니까?')){
        const form = new FormData()
        form.append('resident', this.residentCode);
        this.$axios.post('/task/resident_remove.php', form)
        .then(() => {
          this.getDetail();
          this.residentClear();
          this.residentPopUpClose();
        })
        .catch(err => {
          console.error('에러 발생:', err)
        })
      }
    },
    regidentGetInformation(code){
      this.vehicleClear();
      this.residentState = true;
      this.residentCode= code;
      const form = new FormData()
      form.append('resident', code);

      this.$axios.post('/task/resident_get_information.php', form)
        .then(res => {
          let result = res.data.result.data;
          this.residentName = result.name;
          this.residentMobile = result.mobile;
          this.residentPosition = result.position;
          this.residentSex = result.sex;
          this.residentBirth = result.birth;
          this.residentPopUpOpen();
        })
        .catch(err => {
          console.error('에러 발생:', err)
        })
    },
    vehicleGetInformation(code){
      this.residentClear();
      this.vehicleState = true;
      this.vehicleCode= code;
      const form = new FormData()
      form.append('vehicle', code);
      this.$axios.post('/task/vehicle_get_information.php', form)
        .then(res => {
          let result = res.data.result.data;
          this.vehiclePlateNumber = result.plate_number;
          this.vehicleName = result.name;
          this.vehicleFuel = result.fuel;
          this.vehicleAccessNumber = result.access_number;
          this.vehicleRegistered = result.registered;
          this.vehiclePopUpOpen();
        })
        .catch(err => {
          console.error('에러 발생:', err)
        })
    },
    vehicleRegister(){
        const form = new FormData()
        form.append('complex_code', this.complex);
        form.append('building_code', this.selectedBuildingCode);
        form.append('house_code', this.selectedHouseCode);
        form.append('plate_number', this.vehiclePlateNumber);
        form.append('name', this.vehicleName);
        form.append('fuel', this.vehicleFuel);
        form.append('registered', this.format(this.vehicleRegistered));
        form.append('access_number', this.vehicleAccessNumber);
        this.$axios.post('/task/vehicle_register_manager.php', form)
        .then((data) => {
          if(data.data.response_code == -11){
            alert('이미 등록된 차량입니다.');
          }else {
            this.getDetail();
            this.vehicleClear();
            this.vehiclePopUpClose();
          }  
        })
        .catch(err => {
          console.error('에러 발생:', err)
        })
    },
    vehicleUpdate(){
        const form = new FormData()
        form.append('vehicle', this.vehicleCode);
        form.append('plate_number', this.vehiclePlateNumber);
        form.append('name', this.vehicleName);
        form.append('fuel', this.vehicleFuel);
        form.append('registered', this.format(this.vehicleRegistered));
        form.append('access_number', this.vehicleAccessNumber);
        this.$axios.post('/task/vehicle_update_manager.php', form)
        .then((data) => {
          if(data.data.response_code == -11){
            alert('이미 등록된 차량입니다.');
          }else {
            this.getDetail();
            this.vehicleClear();
            this.vehiclePopUpClose();
          }
        })
        .catch(err => {
          console.error('에러 발생:', err)
        })
    },
    vehicleRemove(){
      if(confirm('삭제하시겠습니까?')){
        const form = new FormData()
        form.append('vehicle', this.vehicleCode);
        this.$axios.post('/task/vehicle_remove.php', form)
        .then(() => {
          this.getDetail();
          this.vehicleClear();
          this.vehiclePopUpClose();
        })
        .catch(err => {
          console.error('에러 발생:', err)
        })
      }
    },
    checkResidentPosition(type) {
      switch (type) {
        case 'H':
          return "세대주";
        case 'F':
          return "세대원";
        default:
          return false;
      }
    },
    checkResidentSex(type){
      switch (type) {
        case 'M':
          return "남";
        case 'F':
          return "여";
        default:
          return false;
      }
    },
    checkVehicleFuel(type){
      switch (type) {
        case 'G':
          return "가솔린";
        case 'D':
          return "디젤";
        case 'L':
          return "LPG";
        case 'E':
          return "전기";
        case 'H':
          return "하이브리드";
        case 'F':
          return "수소";
        default:
          return false;
      }
    }
  }
});
</script>

<style scoped>
  .info_wrapper{
    width:100;
    margin-bottom:50px;
  }
  .selectWrapper{
    width: 150px;
    height:100%;
    border: 1px solid #ccc;
    float:left;
    margin-right:20px;
  }

  .selectWrapper .info{
    width:100%;    
    background-color: #8fb3e2;
    text-align: center;
    height:32px;
    line-height:32px;
  }
  .selectWrapper .select{
    width:100%;
    height: calc(100% - 40px);
    overflow:auto;
  }

  .selectWrapper .select  p{
    padding: 7px;
    
  }
  .content{
    width: calc(100% - 340px);
    height:100%;
    float:left;
    padding:5px;
  }
  .content .table{
    height:200px;
    overflow:auto;
  }
  .content .table .v-table__wrapper thead tr th{
    background-color: #8fb3e2 !important;
    height: 35px !important;
    line-height: 35px !important;
  }
  .content .table .v-table__wrapper tbody tr td{
    height: 35px !important;
    line-height: 35px !important;
  }
  .table_wrapper{
    position:relative;
    margin-bottom:20px;
    height: 280px;
  }
  .table_wrapper p{
    overflow: hidden;
    line-height:50px;
  }
  .table_wrapper .title{
    overflow: hidden;
    margin-bottom:10px;
    font-size: 1.2rem !important;
    font-weight: 600 !important;
    height: 50px;
  }
  .data p{
    height: 35px;
    line-height: 35px;
  }
  .custom-input{
    margin-bottom: 10px;
  }
  .custom-input .v-field {
    background-color: transparent !important;
    border-bottom: 1px solid #ccc;
    border-radius: 0;
  }
  .text-right {
    text-align: right;
  }
  .text-right label{
    line-height: 40px;
  }
  .custom-input input,
  .custom-input .v-field__input input,
  .custom-input .v-field__input > input {
    padding-left: 20px !important;
  }

  .custom-input :deep(input) {
    padding-left: 16px !important;
  }
  .active {
    background-color: #d9e1f1;
  }
  .infoWrapper{
    position:relative;
    width:100%;
    overflow:hidden;
  }
  .infoWrapper .data{
    padding-top:5px;
    overflow:hidden;
    margin-right: 30px;
    float:left;
    width:300px;
  }
  .infoWrapper .data2{
      padding-top:5px;
      overflow:hidden;
      margin-right: 30px;
      float:left;
      width:960px;
  }
  .infoWrapper .data p,
  .infoWrapper .data2 p{
      width: 100px;
  }
  .infoWrapper .title{
    width: 100%;
    overflow: hidden !important;
    margin-bottom:10px !important;
    font-size: 1.2rem !important;
    font-weight: 600 !important;
    height: 30px !important;
  }
  .buttonWrapper{
    position:absolute;
    top:0;
    right:0;
  }
  .custom-textarea :deep(.v-field) {
    width: 100% !important;
    height: 70px !important;
  }
  .custom-textarea :deep(.v-field__input) {
    width: 100% !important;
    height: 70px !important;
  }

</style>
